// extracted by mini-css-extract-plugin
module.exports = {"status":"_1qvNLJLnXMJb","waiting":"_2QRliZDkbK1V","finished":"_1ZjZLvXJgLWP","rejected":"_3i0ZGMJwWqby","processing":"_10IQrmvj2BOE","icon":"_1DGr4H-N17yN"};